<script setup>
import { defineProps, defineEmits } from "vue"

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(["update:show", "callBack"]);
const close = () => {
    emit("callBack");
    setTimeout(() => {
        emit("update:show", false);
    }, 500);
};

</script>
<template>
    <div v-if="show" @click="close" class="w-full h-dvh bg-black bg-opacity-35 absolute z-50 top-0">
        <div @click.stop>
            <slot></slot>
        </div>
    </div>
</template>